export default "__VITE_ASSET__D9xzvNv0__"